/**
 * knowledge_card — the retrieved passages a general answer was drawn from
 * (backend rag/cards/knowledge.py, #28).  Rendered via CardRenderer.
 */
import type { VisualPayload } from "../../types";
import CardShell from "./_CardShell";
import PassageList, { type Passage } from "./_PassageList";

interface Props { payload: VisualPayload }

/** Up to three passages with their sources; an empty-state line when none. */
export default function KnowledgeCard({ payload }: Props) {
  const sec = payload.sections.find((s) => s.section === "passages");
  const passages = (sec?.passages as Passage[] | undefined) ?? [];

  return (
    <CardShell
      title={payload.title}
      source={payload.data_source}
      timestamp={payload.data_timestamp}
      sourceUrl={payload.source_url}
      shareUrl={payload.share_url}
      snapshotPayload={payload.snapshot_eligible ? payload : undefined}
      accent="border-sky-500/20"
    >
      <PassageList
        passages={passages}
        empty={<p className="text-sm text-white/40">No passages found.</p>}
      />
    </CardShell>
  );
}
